export default __webpack_public_path__ + "static/media/roadmap-banner-moon.2928c5cf.svg";